function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import namespace from "./namespace";
import "./script_warning";
export default namespace;
if (!window.Turbolinks) {
  window.Turbolinks = namespace;
  if (!isAMD() && !isCommonJS()) {
    namespace.start();
  }
}
function isAMD() {
  return typeof define == "function" && define.amd;
}
function isCommonJS() {
  return (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == "object" && typeof module != "undefined";
}